import { BackorderLogic } from './BacorderLogic';
import { ENDPOINT } from './constants';
import { RequestAPI } from './Requests';

export interface IRestrictedCommodityGroup {
  id: number;
  name: string;
  min_age: number;
}

export interface IAgeRestrictionSettings {
  restricted_commodity_groups?: IRestrictedCommodityGroup[];
}

export interface IAgeRestrictionRequestDTO {
  data: {
    ageRestriction: IAgeRestrictionSettings;
  };
}

export interface ISettingsRequestDTO {
  data: {
    backorderLogic: BackorderLogic;
  };
}

interface SettingsRequestsInterface {
  getSettings: () => Promise<ISettingsRequestDTO>;
  getAgeRestrictionSettings: () => Promise<IAgeRestrictionRequestDTO>;
}

export const SettingsRequests: SettingsRequestsInterface = {
  getSettings: () => {
    return RequestAPI.get(ENDPOINT.settings.getBackorderLogic);
  },

  getAgeRestrictionSettings: () => {
    return RequestAPI.get(ENDPOINT.settings.getAgeRestriction);
  },
};
